__turbopack_context__.v({
  "checkbox": "Checkbox-module__KdWjrW__checkbox",
  "checkbox__input": "Checkbox-module__KdWjrW__checkbox__input",
  "checkbox__label": "Checkbox-module__KdWjrW__checkbox__label",
});
